import { ENDPOINT } from '~/constants';

import { resolveMutationErrorMessage } from '~/data/utils';

import { vestigasApi } from '~/services/kyClient';
import ToastService from '~/services/toast.service';

import { i18n, log } from '~/utils';

import {
  type ParsingCaseDraftResponse,
  type SaveParsingCaseDraftVariables,
} from '../types';
import { zodParsingCaseDraftResponseSchema } from '../validations';

const ERROR_MESSAGE_BY_STATUS: Record<number, () => string> = {
  404: () =>
    i18n.t(($) => $.saveParsingCaseDraft.error404, {
      ns: 'data',
    }),
  422: () =>
    i18n.t(($) => $.saveParsingCaseDraft.error422, {
      ns: 'data',
    }),
};

/**
 * Park the form state on a parsing case without a retry. Status and jobs
 * stay as they are; `null` clears the draft.
 *
 * @param variables - The case UUID and the draft
 */
export const saveParsingCaseDraft = async ({
  caseId,
  draft,
}: SaveParsingCaseDraftVariables): Promise<ParsingCaseDraftResponse> => {
  try {
    return await vestigasApi
      .put(ENDPOINT.PARSING_CASE.SAVE_DRAFT(caseId), {
        json: { draft },
        validate: { response: zodParsingCaseDraftResponseSchema },
      })
      .json<ParsingCaseDraftResponse>();
  } catch (error) {
    log.error({
      message: 'Error saving parsing case draft',
      error,
    });

    const errorMessage = resolveMutationErrorMessage(
      error,
      ERROR_MESSAGE_BY_STATUS,
      () =>
        i18n.t(($) => $.saveParsingCaseDraft.error.generic, {
          ns: 'data',
        }),
    );
    if (errorMessage) {
      ToastService.error(errorMessage);
    }

    throw error;
  }
};
